import SuppliersReportFilters from './FiltersPage';

export default SuppliersReportFilters;
